module.exports = __webpack_public_path__ + "img/bnr_footer03.9716ecab.png";